










































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogWrapper from '@/components/dialogWrapper.vue';
import LatelyMessage from '@/components/dashboard/latelyMessage.vue';
import LatelyReport from '@/components/dashboard/latelyReport.vue';
import { Student } from '@/modules/student';
import { Account } from '@/modules/admin/me';
import { UserTypes } from '@/enums/userTypes';
import { GenderTypes, getGenderTypeName } from '@/enums/genderTypes';
import { GradeYears, getGradeYearName } from '@/enums/gradeYears';
import { GradesTypes } from '@/enums/gradesTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import { ElForm } from 'element-ui/types/form';
import QRCard from '@/components/student/qrCard.vue';
import { CreditcardSettingResponse } from '@/models/creditcardSettingResponse';
import Axios from 'axios';
import { CollectionAgencyTypes } from '@/enums/collectionAgencyTypes';

@Component({
  components: {
    'lately-report': LatelyReport,
    'qr-card': QRCard,
  },
})
export default class StudentDetails extends Vue {
  private UserTypes = UserTypes;
  private GenderTypes = GenderTypes;
  private getGenderTypeName = getGenderTypeName;
  private GradeYears = GenderTypes;
  private getGradeYearName = getGradeYearName;
  private GradesTypes = GradesTypes;
  private FunctionTypes = FunctionTypes;

  private useCreditcard: boolean = false;

  @Prop() private studentId: string;

  private record = {
    title: ''
  };

  private deleteFormRule = {
    checkUserName: [
      { required: true, message: '削除する生徒名を入力してください' },
      { validator: this.validateCheckUserName, trigger: 'blur' },
    ],
  };

  private validateCheckUserName(rule: any, value: string, callback: any) {
    const userName = ((this.$refs.userDelete as DialogWrapper).form as any).userName;
    if (value.replace(/\s+/g, '') === userName.replace(/\s+/g, '')) {
      callback();
    } else {
      callback(new Error('生徒名が異なります'));
    }
  }

  get user(): Account {
    return this.$store.state.me.user;
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  get userRole(): UserTypes {
    return this.$store.getters['auth/userType'];
  }

  get student(): Student {
    return this.$store.state.student.selectedStudent;
  }

  get availableFunction(): number {
    if (!this.user) {
      return 0;
    }
    return this.user.availableFunctionbit;
  }

  get postalCode(): string {
    if (!this.student || !this.student.postalCode) {
      return '';
    } else {
      const left = this.student.postalCode.substring(0, 3);
      const right = this.student.postalCode.substring(3, 7);
      if (!right) {
        return left;
      } else {
        return `${left}-${right}`;
      }
    }
  }

  get studentName(): string {
    if (!this.student) {
      return '';
    } else {
      return `${this.student.lastName}　${this.student.firstName}`;
    }
  }

  get collectionAgency(): CollectionAgencyTypes {
    if (!this.user || !this.user.collectionAgency) {
      return CollectionAgencyTypes.None;
    }
    return this.user.collectionAgency;
  }

  get isPaypal() {
    switch (this.collectionAgency) {
      case CollectionAgencyTypes.PayPalAndCramSchool:
      case CollectionAgencyTypes.PayPalAndOther:
        return true;
      default:
        return false;
    }
  }

  private mounted() {
    this.loadData();
  }

  private deactivated() {
    this.$destroy();
  }

  private async loadData() {
    try {
      await this.$store.dispatch('student/selectStudent', this.studentId);
    } catch (error) {
      //
    }

    if (!this.student) {
      this.$router.push({
        name: 'StudentList',
      });
    }

    this.useCreditcard = false;

    if (!this.user) {
      await this.$store.dispatch('me/fetchMyData');
    }

    switch (this.userRole) {
      case UserTypes.All:
      case UserTypes.Admin:
      case UserTypes.Owner:
      case UserTypes.AdminTutor:
        if ((this.availableFunction & FunctionTypes.Bill) === FunctionTypes.Bill) {
          // 請求機能
          try {
            const res = await Axios.get<CreditcardSettingResponse>('/api/bill-settings/creditcard');
            if (res.data.enabled) {
              this.useCreditcard = true;
            }
          } catch (error) {
            //
          }
        }
        break;
    }
  }

  private async reissueDocument() {
    const fullName = `${this.student.lastName}　${this.student.firstName}`;

    try {
      await this.$confirm(`生徒『${fullName}』のパスワードが個人情報のため初期化されます。よろしいですか？`, '案内資料の再発行', {
        confirmButtonText: '再発行',
        cancelButtonText: 'キャンセル',
        type: 'info'
      });
    } catch (error) {
      return;
    }

    // パスワード再発行処理
    try {
      await this.$store.dispatch('student/resetStudent', this.student);
      this.$notify({
        title: '再発行完了',
        message: `生徒『${fullName}』の案内資料を再発行しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: '再発行エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private editStudent() {
    this.$router.push({
      name: 'StudentEdit',
      params: {
        studentId: this.studentId
      }
    });
  }

  private submitDeleteForm() {
    (this.$refs.deleteForm as ElForm).validate((valid) => {
      if (valid) {
        (this.$refs.userDelete as DialogWrapper).submit();
      } else {
        return false;
      }
    });
  }

  private async deleteStudent() {
    const fullName = `${this.student.lastName}　${this.student.firstName}`;

    try {
      const form = {
        userName: fullName,
        checkUserName: '',
      };
      await (this.$refs.userDelete as DialogWrapper).open({...form});
    } catch (error) {
      return;
    }

    try {
      await this.$store.dispatch('student/deleteStudent', this.studentId);
      this.$router.push({ name: 'StudentList' });
      this.$notify({
        title: '削除完了',
        message: `生徒『${fullName}』を削除しました。`,
        position: 'bottom-right'
      });
    } catch (error) {
      this.$notify.error({
        title: 'エラー',
        message: error.message,
        position: 'bottom-right'
      });
    }
  }

  private async onQRCodeDownload() {
    const fileName = `QRコード_${this.student.userId}_${this.student.lastName}${this.student.firstName}.png`;
    const imageType = 'image/png';

    const canvas = (this.$refs.qrcard as Vue).$el.firstElementChild as HTMLCanvasElement;
    const base64 = canvas.toDataURL(imageType);
    const blob = this.Base64toBlob(base64);

    if (!(window.navigator as any).msSaveOrOpenBlob) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const url = (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
    }
  }

  private onQRCodeDownloadQROnly() {
    const fileName = `QRコード_${this.student.userId}_${this.student.lastName}${this.student.firstName}.png`;
    const imageType = 'image/png';
    const canvas = (this.$refs.qrcode as Vue).$el.firstElementChild as HTMLCanvasElement;
    const base64 = canvas.toDataURL(imageType);
    const blob = this.Base64toBlob(base64);

    if (!(window.navigator as any).msSaveOrOpenBlob) {
      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.setAttribute('download', fileName);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } else {
      const url = (window.navigator as any).msSaveOrOpenBlob(blob, fileName);
    }
  }

  private Base64toBlob(base64: string) {
    const tmp = base64.split(',');
    const data = atob(tmp[1]);
    const mime = tmp[0].split(':')[1].split(';')[0];
    const buf = new Uint8Array(data.length);
    for (let i = 0; i < data.length; i++) {
      buf[i] = data.charCodeAt(i);
    }
    return new Blob([buf], { type: mime });
  }

  private onViewRecord(gradesType: GradesTypes) {
    this.$router.push({
      name: 'RecordView',
      params: {
        studentId: this.studentId,
        tab: String(gradesType),
        schoolType: String(this.student.schoolType),
      },
    });
  }

  private gotoCalendar() {
    this.$router.push({
      name: 'StudentCalendar',
      params: {
        studentId: this.studentId
      }
    });
  }

  private gotoCreditcard() {
    this.$router.push({
      name: 'StudentCreditcard',
      params: {
        studentId: this.studentId
      }
    });
  }
}
